import DeDE from './de-DE.svg?sprite'
import EnUs from './en-US.svg?sprite'
import EsEs from './es-ES.svg?sprite'
import FrFR from './fr-FR.svg?sprite'
import IdID from './id-ID.svg?sprite'
import ItIT from './it-IT.svg?sprite'
import PlPL from './pl-PL.svg?sprite'
import PtBR from './pt-BR.svg?sprite'
import TrTR from './tr-TR.svg?sprite'

// copied from https://github.com/HatScripts/circle-flags
// TODO fix blurry on Safari — replace Mask with border-radius

export const localeIcons = {
    'en-US': EnUs,
    'es-ES': EsEs,
    'de-DE': DeDE,
    'fr-FR': FrFR,
    'it-IT': ItIT,
    'pt-BR': PtBR,
    'tr-TR': TrTR,
    'pl-PL': PlPL,
    'id-ID': IdID,
}
